/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DisplayBrightnessV2Slider_DisplayFragment = { __typename: 'Display', id: string, brightnessV2?: { __typename: 'BrightnessV2State', reported: { __typename: 'BrightnessV2Value', value: number, autoBrightness?: boolean | null }, desired?: { __typename: 'BrightnessV2Value', value: number, autoBrightness?: boolean | null } | null } | null };

export type BulkUpdateBrightnessV2MutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateBrightnessV2Input;
}>;


export type BulkUpdateBrightnessV2Mutation = { __typename: 'Mutation', displayBulkUpdateBrightnessV2: { __typename: 'DisplayBulkUpdateBrightnessV2Payload', displays: Array<{ __typename: 'Display', id: string, brightnessV2?: { __typename: 'BrightnessV2State', reported: { __typename: 'BrightnessV2Value', value: number, autoBrightness?: boolean | null }, desired?: { __typename: 'BrightnessV2Value', value: number, autoBrightness?: boolean | null } | null } | null }> } };

export const DisplayBrightnessV2Slider_DisplayFragmentDoc = gql`
    fragment DisplayBrightnessV2Slider_display on Display {
  id
  brightnessV2 {
    reported {
      value
      autoBrightness
    }
    desired {
      value
      autoBrightness
    }
  }
}
    `;
export const BulkUpdateBrightnessV2Document = gql`
    mutation BulkUpdateBrightnessV2($input: DisplayBulkUpdateBrightnessV2Input!) {
  displayBulkUpdateBrightnessV2(input: $input) {
    displays {
      id
      ...DisplayBrightnessV2Slider_display
    }
  }
}
    ${DisplayBrightnessV2Slider_DisplayFragmentDoc}`;
export type BulkUpdateBrightnessV2MutationFn = ApolloReactCommon.MutationFunction<BulkUpdateBrightnessV2Mutation, BulkUpdateBrightnessV2MutationVariables>;

/**
 * __useBulkUpdateBrightnessV2Mutation__
 *
 * To run a mutation, you first call `useBulkUpdateBrightnessV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBrightnessV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBrightnessV2Mutation, { data, loading, error }] = useBulkUpdateBrightnessV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateBrightnessV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdateBrightnessV2Mutation, BulkUpdateBrightnessV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUpdateBrightnessV2Mutation, BulkUpdateBrightnessV2MutationVariables>(BulkUpdateBrightnessV2Document, options);
      }
export type BulkUpdateBrightnessV2MutationHookResult = ReturnType<typeof useBulkUpdateBrightnessV2Mutation>;
export type BulkUpdateBrightnessV2MutationResult = ApolloReactCommon.MutationResult<BulkUpdateBrightnessV2Mutation>;
export type BulkUpdateBrightnessV2MutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdateBrightnessV2Mutation, BulkUpdateBrightnessV2MutationVariables>;